@if (option) {
<div class="flex flex-middle flex-justify-center cursor-pointer option option--color option--listing"
     [class.option--picked]="selected">
    <span class="ratio-1-1 option__inner"
          [class.is-not-color]="!option.hasColor || (!option.swatch && !option.hasImage)"
          [class.b-a]="!selected && ( option.hasColor && (option.swatch | isWhite))"
          [bgContrast]="option.swatch"
          [tolerance]="200">
        @if (option.hasImage) {
        <img [dfImage]="option.swatch"
             [dfSrcset]="'14w, 28w, 42w'"
             [ratio]="1"
             fill>
        } @else {
        <i class="fill"
           [ngStyle]="{'background-color': option.swatch || '#FFFFFF'}"></i>
        }
    </span>
</div>
}
